import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import TrackRecord from "@/components/TrackRecord";
import Roster from "@/components/Roster";
import Credibility from "@/components/Credibility";
import ContactSection from "@/components/ContactSection";
import AuditSection from "@/components/AuditSection";
import RadioSection from "@/components/RadioSection";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#08080A] text-[#F2F2F5] min-h-screen antialiased" data-testid="app-root">
      <div className="noise-overlay" />
      <Toaster theme="dark" position="bottom-right" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <TrackRecord />
        <AuditSection />
        <Roster />
        <RadioSection />
        <Credibility />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
